import pokerTable from "./images/projectImages/stol-poker-java.JPG";
import pokerTable2 from "./images/projectImages/stol2-poker-java.JPG";
import loginPoker from "./images/projectImages/login-poker-Java.JPG";
import exerciseDiaryLogin from "./images/projectImages/exerciseDiaryLogin.JPG";
import exerciseDiaryRegister from "./images/projectImages/exerciseDiaryRegister.JPG";
import exerciseDiaryMainWindow from "./images/projectImages/exerciseDiaryMainWindow.JPG";
import exerciseDiaryDifferentOptions from "./images/projectImages/exerciseDiaryDifferentOptions.JPG";
import exerciseDiaryRank from "./images/projectImages/exerciseDiaryRank.JPG";
import exerciseDiaryChart from "./images/projectImages/exerciseDiaryChart.JPG";
import whaleNotesLoginRegister from "./images/projectImages/WhaleNotesLoginRegister.jpg";
import whaleNotesMainScreen from "./images/projectImages/WhaleNotesMainScreen.jpg";
import whaleNotesWelcomeScreen from "./images/projectImages/WhaleNotesWelcomeScreen.jpg";
import whaleNotesMap from "./images/projectImages/WhaleNotesMap.png";
import azure from "./images/projectImages/azure.jpg";
import python from "./images/projectImages/python.JPG";
import wphp1 from "./images/projectImages/wgrywaniePlikowPHP.jpg";
import wphp2 from "./images/projectImages/wgrywaniePlikowPHP2.JPG";
import dbphp from "./images/projectImages/bazaDanychPHP.JPG";
import dbphp2 from "./images/projectImages/bazaDanychListaGierPHP.JPG";


const projectImages = {
    pokerTable,
    pokerTable2,
    loginPoker,
    exerciseDiaryLogin,
    exerciseDiaryRegister,
    exerciseDiaryMainWindow,
    exerciseDiaryDifferentOptions,
    exerciseDiaryRank,
    exerciseDiaryChart,
    whaleNotesWelcomeScreen,
    whaleNotesLoginRegister,
    whaleNotesMainScreen,
    azure,
    python,
    wphp1,
    wphp2,
    dbphp,
    dbphp2,
    whaleNotesMap
};

export default projectImages;
